import { ScrollTopWrapper } from './ScrollTop.styled';
import { transformWidgetProps } from '@/components/WidgetMaker/utils/common';
import { getStyleForProps } from '@/components/DesignSystem/ModernTheme/utils/getStylesConfig';
import { FloatingWhatsapp } from '@/components/FloatingWhatsapp';
import { useEffect, useState } from 'react';
import { ScrollTopArrow } from '@/assets/svgExports/ScrollTopArrow';
import { useSelector } from 'react-redux';
import { useSSRSelector } from '@/redux/ssrStore';

const ScrollTop = (props) => {
  const [floatingButtonState] = useState(
    transformWidgetProps(props?.config?.scrollToTop?.config)
  );
  const { storeData } = useSSRSelector((state) => ({
    storeData: state.storeReducer.store,
  }));
  const { widgetData } = useSelector((state) => ({
    widgetData: state.widgetsReducer,
  }));
  const [propStyle, setPropStyle] = useState(storeData?.theme?.style_template);

  useEffect(() => {
    if (widgetData?.activeStyleTemplate) {
      setPropStyle(getStyleForProps(widgetData?.activeStyleTemplate));
    } else {
      setPropStyle(getStyleForProps(storeData?.theme?.style_template));
    }
  }, [widgetData?.activeStyleTemplate, storeData?.theme?.style_template]);

  const onBtnClick = () => {
    const targetElement = document.getElementById('Header');
    if (targetElement) {
      targetElement.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
        inline: 'start',
      });
    }
  };
  return (
    <ScrollTopWrapper
      themeConfig={propStyle}
      styleConfig={floatingButtonState?.ScrollToTop?.styleConfig?.alignment}
      className={`${
        props?.inBuilder && props?.showPreview
          ? 'btn_scroll_builder'
          : `btn_scroll_preview_${props?.device}`
      } ${
        props?.inBuilder === false && props?.showPreview === undefined
          ? 'btn_scroll_cfe'
          : ''
      }`}
    >
      {props?.config?.scrollToTop?.isEnabled && (
        <button className="scroll" onClick={onBtnClick}>
          <ScrollTopArrow color={propStyle?.buttonPrimary?.color} />
        </button>
      )}
      {props?.config?.whatsappCTA?.isEnabled && (
        <FloatingWhatsapp overRideDefaultStyle={true} />
      )}
    </ScrollTopWrapper>
  );
};

export default ScrollTop;
